import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
}
export function PageTransition({
  children
}: PageTransitionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="w-full min-h-screen" data-id="element-117" data-mp="2z30m9ffr3jrq">
      {children}
    </motion.div>;
}